module.exports = __webpack_public_path__ + "img/collapse_open.6db089e6.svg";